import { createContext } from 'react'

import type { ContextType } from './types'

export const initialValues = {
  me: {},
  refetch: () => {}
}

export const defaultContext: ContextType = {
  me: initialValues.me,
  setMe: () => {},
  refetch: () => new Promise(() => {})
}

export const ProfileContext = createContext<ContextType>(defaultContext)
